export default "__VITE_ASSET__ebd65c9d__"